// extracted by mini-css-extract-plugin
module.exports = {"Controls":"Controls_Controls__311Zq","Control":"Controls_Control__2U-zL"};